module.exports = __webpack_public_path__ + "img/user-line.ff0dc957.svg";